// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iXeYAhET7bacgzMV6NRN{background-color:#fff;min-height:50px;padding:0px 50px 50px 20px !important}`, "",{"version":3,"sources":["webpack://./src/pages/infoperso/InfoPerso.scss"],"names":[],"mappings":"AAEA,sBACE,qBAAA,CACA,eAAA,CACA,qCAAA","sourcesContent":["@use \"src/css/global.scss\";\n\n.formContainer {\n  background-color: white;\n  min-height: 50px;\n  padding: 0px 50px 50px 20px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `iXeYAhET7bacgzMV6NRN`
};
export default ___CSS_LOADER_EXPORT___;
